// 定义文档和内容的接口
interface Content {
    type: 'text' | 'image';
    data: string;
}

interface Document {
    title: string;
    contents: Content[];
}

// 模拟文档数据
const documents: Document[] = [
    {
        title: 'Introduction to React',
        contents: [
            {
                type: 'text',
                data: 'React is a JavaScript library for building user interfaces.'
            },
            {
                type: 'text',
                data: 'It lets you compose complex UIs from small and isolated pieces of code called "components".'
            }
        ]
    },
    {
        title: 'React Router Overview',
        contents: [
            {
                type: 'text',
                data: 'React Router is a standard library for routing in React.'
            },
            {
                type: 'image',
                data: 'https://example.com/path-to-react-router-image.png'  // Assume this is a valid URL to an image about React Router
            },
            {
                type: 'text',
                data: 'It helps in handling navigation from one view to another.'
            }
        ]
    },
    {
        title: 'Using TypeScript with React',
        contents: [
            {
                type: 'text',
                data: 'TypeScript can greatly improve the way you develop React applications by adding type safety.'
            },
            {
                type: 'image',
                data: 'https://example.com/path-to-typescript-react-image.png' // Assume this is another valid URL
            }
        ]
    }
];

export default documents;

